<template>
  <div>
    <Header page-name="Example" logout-dropdown-button-text="admin" fibermap-link="/">
      <template #logout>
        <b-dropdown text="admin" toggle-class="text-secondary" variant="link" right>
          <b-dropdown-item>Potatoes</b-dropdown-item>
          <b-dropdown-item>Not Potatoes :[</b-dropdown-item>
        </b-dropdown>
      </template>
    </Header>
  </div>
</template>

<script>
import Header from '@/components/header/Header.vue';

export default {
  components: {
    Header,
  },
};
</script>
